'use client';

import HomeButton from '../HomeButton';
import ScreenExpandToggleButton from '../ScreenExpandToggleButton';
import VolumeToggle from '../VolumeToggleButton';
import styles from './userActionToolbar.module.scss';

export default function UserActionToolBar() {
  return (
    <div className={styles.userActionToolbar}>
      <VolumeToggle />
      <ScreenExpandToggleButton />
      <HomeButton />
    </div>
  );
}
